import React, { Component } from 'react';
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Icon,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Table,
} from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';

import '../tabRow.less';
import { queryIchapterappType } from '@api/core/dict';
import { queryDeleteAttachment, queryFilePreview } from '@api/pub/attachment';
import { queryMaterialDocumentListBR } from '@api/administrative/material';

import CompanySearch from '@comm/companySearch';
import UploadFile from '@comm/upload/UploadFileTable';
import { BackBtn } from '@comm/BackBtn';
import { Link } from 'react-router';

const FormItem = Form.Item;
const { TextArea } = Input;
const { Option } = Select;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ichapterappType: [],
      chaptersList: [{ id: 0 }],
      effectsList: [{ id: 0 }],
      chaptersCount: 1,
      effectsCount: 1,
      isReturnRow: {},
      isReturnVisible: false,
      descFile: {},
      delFiles: [],
    };
  }

  componentDidMount() {
    const { data } = this.props;
    this.getDocumentList();
    if (data.chapters && data.chapters.length) {
      data.chapters.map(item => {
        item.id = item.uuid;
        return 1;
      });
      this.setState({
        chaptersList: data.chapters,
        chaptersCount: data.chapters.length,
      });
    }
    if (data.effects && data.effects.length) {
      data.effects.map(item => {
        item.id = item.uuid;
        return 1;
      });
      this.setState({
        effectsList: data.effects,
        effectsCount: data.effects.length,
      });
    }
    queryIchapterappType().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          ichapterappType: res.data,
        });
      }
    });
  }

  // 提交
  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit, data } = this.props;
    const { chaptersList, effectsList } = this.state;
    const params = {
      ...data,
      ...this.props.form.getFieldsValue(),
    };

    this.props.form.validateFields((err, values) => {
      if (!err) {
        chaptersList.map(item => {
          item.companyUuid = values[`companyUuid${item.id}`];
          item.company = values[`company${item.id}`];
          item.seal = values[`seal${item.id}`];
          item.type = values[`type${item.id}`];

          delete params[`companyUuid${item.id}`];
          delete params[`company${item.id}`];
          delete params[`seal${item.id}`];
          delete params[`type${item.id}`];
          return item;
        });
        effectsList.map(item => {
          item.name = values[`name${item.id}`];
          item.files = values[`files${item.id}`];
          item.price = values[`price${item.id}`];
          item.count = values[`count${item.id}`];
          item.isReturn = values[`isReturn${item.id}`];

          delete params[`name${item.id}`];
          delete params[`files${item.id}`];
          delete params[`price${item.id}`];
          delete params[`count${item.id}`];
          delete params[`isReturn${item.id}`];
          return item;
        });
        params.chapters = chaptersList;
        params.effects = effectsList;
        handSubmit(params);
        if (this.state.delFiles.length > 0) {
          this.state.delFiles.map(item => {
            queryDeleteAttachment({
              uuid: item.uuid,
            });
            return item;
          });
        }
      }
    });
  };

  /**
   *文件删除
   */
  fileRemove = file => {
    const { delFiles } = this.state;
    delFiles.push(file);
    this.setState({ delFiles });
  };

  // 公司变化，记录公司名称
  handleCompanyChange = (id, value, option) => {
    this.props.form.setFieldsValue({
      [`company${id}`]: option ? option.props.children : '',
    });
  };

  // 获取说明性文件
  getDocumentList = () => {
    const params = {
      condition: '事件类型_帮实_desc',
    };
    queryMaterialDocumentListBR(params).then(res => {
      if (res.statusCode === 200 && res.data.length > 0) {
        this.setState({
          descFile: res.data[0].files[0],
        });
      }
    });
  };

  start = e => {
    this.submit(e, null, 'start');
  };

  handleIsReturn = () => {
    this.setState({
      isReturnVisible: true,
    });
  };

  handleIsReturnOk = () => {
    const { effectsList, isReturnRow } = this.state;
    this.props.form.validateFields(
      [`returnCount${isReturnRow.id}`, `returnExpectedDate${isReturnRow.id}`],
      (err, values) => {
        if (!err) {
          const returnCount = values[`returnCount${isReturnRow.id}`];
          const returnExpectedDate = values[`returnExpectedDate${isReturnRow.id}`];
          effectsList.map(item => {
            if (item.id === isReturnRow.id) {
              item.returnCount = returnCount;
              item.returnExpectedDate = returnExpectedDate;
            }
            return item;
          });
          this.setState({
            isReturnVisible: false,
            effectsList,
          });
        }
      },
    );
  };

  handleIsReturnCancel = () => {
    this.setState({
      isReturnVisible: false,
    });
  };

  addChapters = () => {
    const { chaptersList, chaptersCount } = this.state;
    chaptersList.push({ id: chaptersCount });
    this.setState({
      chaptersList,
      chaptersCount: chaptersCount + 1,
    });
  };

  deleteChapters = id => {
    const { chaptersList } = this.state;
    this.setState({
      chaptersList: chaptersList.filter(item => item.id !== id),
    });
  };

  addEffects = () => {
    const { effectsList, effectsCount } = this.state;
    effectsList.push({ id: effectsCount });
    this.setState({
      effectsList,
      effectsCount: effectsCount + 1,
    });
  };

  deleteEffects = id => {
    const { effectsList } = this.state;
    this.setState({
      effectsList: effectsList.filter(item => item.id !== id),
    });
  };

  isReturnChange = (record, e) => {
    const { effectsList } = this.state;
    let { isReturnRow } = this.state;
    if (e === '1') {
      this.setState({
        isReturnRow: record,
      });
      this.handleIsReturn();
    } else {
      isReturnRow = {};
      effectsList.map(item => {
        if (item.id === record.id) {
          delete item.returnCount;
          delete item.returnExpectedDate;
        }
        return item;
      });

      this.setState({
        effectsList,
        isReturnRow,
      });
    }
    return e;
  };

  isReturnTrue = record => {
    this.setState({
      isReturnRow: record,
    });
    this.handleIsReturn();
  };

  chaptersColumns = () => {
    const { getFieldDecorator } = this.props.form;
    const { chaptersList } = this.state;
    const arr = [
      {
        title: '*用章公司',
        dataIndex: 'companyUuid',
        key: 'companyUuid',
        width: '35%',
        render: (text, record) => {
          getFieldDecorator(`company${record.id}`, {
            initialValue: record.company,
          });
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`companyUuid${record.id}`, {
                rules: [{ required: true, message: '请选择用章公司' }],
                initialValue: record.companyUuid,
              })(
                <CompanySearch
                  companyName={record.company}
                  companyUuid={record.companyUuid}
                  onChange={(value, option) => this.handleCompanyChange(record.id, value, option)}
                  {...this.props}
                />,
              )}
            </FormItem>
          );
        },
      },
      {
        title: '*用章类型',
        dataIndex: 'type',
        key: 'type',
        width: '30%',
        render: (text, record) => {
          let defaultType;
          switch (text) {
            case 0:
              defaultType = '0';
              break;
            case 1:
              defaultType = '1';
              break;
            case 2:
              defaultType = '2';
              break;
            default:
              break;
          }
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`type${record.id}`, {
                rules: [{ required: true, message: '请选择用章类型' }],
                initialValue: defaultType,
              })(
                <Select placeholder="请选择用章类型">
                  <Option key="0">公章</Option>
                  <Option key="1">合同章</Option>
                  <Option key="2">法人章</Option>
                </Select>,
              )}
            </FormItem>
          );
        },
      },
      {
        title: '是否外借',
        dataIndex: 'seal',
        key: 'seal',
        render: (text, record) => {
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`seal${record.id}`, {
                rules: [{ required: true, message: '请选择是否外借' }],
                initialValue: record.seal ? `${record.seal}` : '0',
              })(
                <Select>
                  <Option key="0">否</Option>
                  <Option key="1">是</Option>
                </Select>,
              )}
            </FormItem>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        key: 'done',
        render: (text, record) => {
          return (
            <div style={{ margin: 0, height: '45px' }}>
              {chaptersList && chaptersList.length > 1 ? (
                <Link onClick={() => this.deleteChapters(record.id)}>删除</Link>
              ) : null}
            </div>
          );
        },
      },
    ];

    if (!chaptersList || chaptersList.length === 1) {
      arr.pop();
    }
    return arr;
  };

  effectsColumns = () => {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { effectsList } = this.state;

    const arr = [
      {
        title: '文件名称',
        dataIndex: 'name',
        key: 'name',
        width: '18%',
        render: (text, record) => {
          const filesArr = getFieldValue(`files${record.id}`) || [];
          let defaultName = filesArr[0] ? filesArr[0].name : '';
          const index = defaultName.indexOf('.');
          defaultName = defaultName.slice(0, index);
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`name${record.id}`, {
                rules: [{ required: true, message: '请填写文件名称' }],
                initialValue: record.name || defaultName || null,
              })(<Input placeholder="请输入文件名称" />)}
            </FormItem>
          );
        },
      },
      {
        title: '*附件',
        dataIndex: 'files',
        key: 'files',
        width: '22%',
        render: (text, record) => {
          return (
            <FormItem>
              {getFieldDecorator(`files${record.id}`, {
                rules: [{ required: true, message: '请上传附件' }],
                initialValue: record.files || [],
              })(
                <UploadFile
                  type="ghost"
                  fileList={record.file}
                  isPreview
                  onRemove={this.fileRemove}
                />,
              )}
            </FormItem>
          );
        },
      },
      {
        title: '涉及金额',
        dataIndex: 'price',
        key: 'price',
        width: '18%',
        render: (text, record) => {
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`price${record.id}`, {
                initialValue: record.price || null,
              })(<InputNumber placeholder="可填写涉及金额" style={{ width: '100%' }} />)}
            </FormItem>
          );
        },
      },
      {
        title: '*数量',
        dataIndex: 'count',
        key: 'count',
        width: '15%',
        render: (text, record) => {
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`count${record.id}`, {
                rules: [{ required: true, message: '请填写数量' }],
                initialValue: record.count || null,
              })(<InputNumber placeholder="请填写数量" style={{ width: '100%' }} />)}
            </FormItem>
          );
        },
      },
      {
        title: '*是否归还',
        dataIndex: 'isReturn',
        key: 'isReturn',
        width: '18%',
        render: (text, record) => {
          const returnRender =
            record.returnCount && record.returnExpectedDate ? (
              <span style={{ paddingLeft: '5px', whiteSpace: 'nowrap' }}>
                {record.returnCount}份，
                {moment.unix(record.returnExpectedDate / 1000).format('YYYY-MM-DD')}
              </span>
            ) : (
              <Link
                style={{ paddingLeft: '5px', whiteSpace: 'nowrap' }}
                onClick={() => this.isReturnTrue(record)}
              >
                请填写归还信息
              </Link>
            );
          return (
            <div style={{ margin: 0, height: '60px' }}>
              <FormItem style={{ margin: 0, height: '36px' }}>
                {getFieldDecorator(`isReturn${record.id}`, {
                  rules: [{ required: true, message: '请选择是否归还' }],
                  initialValue: record.isReturn ? `${record.isReturn}` : '0',
                })(
                  <Select onSelect={e => this.isReturnChange(record, e)}>
                    <Option key="0">否</Option>
                    <Option key="1">是</Option>
                  </Select>,
                )}
              </FormItem>
              {getFieldValue(`isReturn${record.id}`) === '1' ? returnRender : null}
            </div>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        key: 'done',
        render: (text, record) => {
          return (
            <div style={{ margin: 0, height: '45px' }}>
              {effectsList && effectsList.length > 1 ? (
                <Link onClick={() => this.deleteEffects(record.id)}>删除</Link>
              ) : null}
            </div>
          );
        },
      },
    ];
    if (!effectsList || effectsList.length <= 1) {
      arr.pop();
    }
    return arr;
  };

  // 说明性title
  descTitle = () => {
    const { descFile } = this.state;
    return (
      <span>
        事件类型
        <a onClick={() => queryFilePreview(descFile)}>
          <Icon type="question-circle" />
        </a>
      </span>
    );
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { isReturnVisible, chaptersList, effectsList, isReturnRow } = this.state;
    const { isSubmitting, data } = this.props;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
        md: { span: 18 },
      },
    };

    const formItemLayout2 = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
        md: { span: 15 },
      },
    };

    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
          <Button
            icon="upload"
            type="primary"
            style={{ marginRight: 10 }}
            onClick={this.start}
            loading={isSubmitting}
          >
            发起申请
          </Button>
          {data.uuid ? (
            <Button icon="delete" style={{ marginRight: 10 }} onClick={this.props.handleDelete}>
              删除
            </Button>
          ) : null}
        </div>
        <Card bordered={false} style={{ width: '100%' }}>
          <Row>
            <Col span={12}>
              <FormItem label={this.descTitle()} {...formItemLayout2}>
                {getFieldDecorator('type', {
                  rules: [{ required: true, message: '请选择用章事件类型' }],
                  initialValue: data.type || data.type === 0 ? `${data.type}` : undefined,
                })(
                  <Select placeholder="请选择用章事件类型">
                    {this.state.ichapterappType.map(item => {
                      return (
                        <Option key={item.value} value={item.value}>
                          {item.key}
                        </Option>
                      );
                    })}
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <FormItem label="对方公司" {...formItemLayout2}>
                {getFieldDecorator('otherCompany', {
                  initialValue: data.otherCompany || null,
                })(<Input placeholder="请输入对方公司名称" />)}
              </FormItem>
            </Col>
          </Row>
          <FormItem {...formItemLayout} label="用章类别">
            {getFieldDecorator('chapters')(
              <div>
                <Table
                  columns={this.chaptersColumns()}
                  dataSource={chaptersList}
                  pagination={false}
                  rowKey="id"
                  rowClassName="tabRow"
                />
                <Button onClick={this.addChapters} style={{ width: '100%', borderStyle: 'dashed' }}>
                  +添加用章
                </Button>
              </div>,
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="申请附件">
            {getFieldDecorator('effects')(
              <div>
                <Table
                  columns={this.effectsColumns()}
                  dataSource={effectsList}
                  pagination={false}
                  rowKey="id"
                  rowClassName="tabRow"
                />
                <Button onClick={this.addEffects} style={{ width: '100%', borderStyle: 'dashed' }}>
                  +添加附件
                </Button>
              </div>,
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="申请说明">
            {getFieldDecorator('reason', {
              rules: [{ required: true, message: '请填写申请说明' }],
              initialValue: data.reason || null,
            })(<TextArea style={{ minHeight: 32 }} rows={4} placeholder="请填写申请说明" />)}
          </FormItem>
          <FormItem label="申请人" {...formItemLayout}>
            {getFieldDecorator('crName')(<span>{this.props.accountInfo.userName}</span>)}
          </FormItem>
        </Card>
        {isReturnVisible ? (
          <Modal
            title="归还详细"
            visible={isReturnVisible}
            onOk={this.handleIsReturnOk}
            onCancel={this.handleIsReturnCancel}
          >
            <Row>
              <FormItem {...formItemLayout2} label="归还数量">
                {getFieldDecorator(`returnCount${isReturnRow.id}`, {
                  rules: [{ required: true, message: '请选择归还数量' }],
                  initialValue: isReturnRow.returnCount || null,
                })(<InputNumber style={{ width: '60%' }} />)}
              </FormItem>
            </Row>
            <Row>
              <FormItem {...formItemLayout2} label="归还时间">
                {getFieldDecorator(`returnExpectedDate${isReturnRow.id}`, {
                  rules: [{ required: true, message: '请选择归还时间' }],
                  initialValue: isReturnRow.returnExpectedDate
                    ? moment(isReturnRow.returnExpectedDate, 'YYYY/MM/DD')
                    : null,
                })(<DatePicker />)}
              </FormItem>
            </Row>
          </Modal>
        ) : null}
      </Form>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create({ wrappedComponentRef: true })(BaseForm));



// WEBPACK FOOTER //
// ./src/components/administrative/seal/FormBase.js